<template>
    <u-btn-icon-outlined-rounded v-bind="$attrs" @click="$emit('click')">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-btn-icon-outlined-rounded>
</template>

<script>
import UBtnIconOutlinedRounded from "@/components/publish/styles/buttons/u-btn-icon-outlined-rounded.vue";

export default {
    props: {
    },
    components: {
        UBtnIconOutlinedRounded,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
